import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import auth from '../services/auth'

Vue.use(Router);

const router = new Router ({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: () => import('../components/Dashboard'),
            meta: {
                auth: true
            }
        },
        {
            path: '/profile/:id',
            name: 'Profile',
            component: () => import('../components/Profile'),
            meta: {
                auth: true
            }

        },

        {
            path: '/profile/edit/:id',
            name: 'EditProfile',
            component: () => import('../partials/EditProfile'),
            meta: {
                auth: true
            }

        },
        {
            path: '/users-list',
            name: 'Users',
            component: () => import('../components/Users'),
            meta: {
                auth: true
            }
        },
        {
            path: '/patients',
            name: 'Patients',
            component: () => import('../components/Patients'),
            meta: {
                auth: true
            }
        },
        {
            path: '/studies',
            name: 'Studies',
            component: () => import('../components/Studies'),
            meta: {
                auth: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('../components/Login')
        },
        {
            path: '/working-space/:id',
            name: 'WorkingSpace',
            component: () => import('../partials/WorkingSpace'),
            meta: {
                auth: true
            }
        },

        {
            path: '/drawing-space/:id',
            name: 'DrawingSpace',
            component: () => import('../partials/DrawingSpace'),
            meta: {
                auth: true
            }
        }
    ]
});
router.beforeEach((to, from, next)=>{

    // Redirect to Login for not signed users
    if(to.meta.auth) {
        if(!auth.isAuthenticated()) {
            router.push('/login')

        }
        next()
    }

    if(to.name !== 'login') {
        store.commit('setLoading', true)
    }

    next()
})
router.afterEach((to)=>{
    if(to.name === 'login') {
        store.commit('setLoading', false)
    }

})
export default router;
